<!--
 * @Descripttion: 个人信息页面组件
 * @Author: congz
 * @Date: 2020-07-11 14:59:00
 * @LastEditors: congz
 * @LastEditTime: 2020-08-13 11:30:55
--> 

<template>
  <div class="user-details" id="user-details" name="user-details">
    <div class="user-details-layout">
      <el-row :gutter="10">
        <div>
          <CenterMenu></CenterMenu>
        </div>
        <el-col :span="20">
          <div class="user-details-content">
            <div class="extra"></div>
            <div class="user-details-title">
              <p>Personal Information</p>
            </div>
            <div class="user-details-form">
              <el-form ref="form" :model="form" status-icon :rules="rules" label-width="80px">
                <el-form-item label="avatar:">
                  <el-upload
                    class="avatar-uploader"
                    action
                    label="description"
                    ref="upload"
                    :before-upload="fnBeforeUpload"
                    :http-request="fnUploadRequest"
                    :show-file-list="false"
                  >
                    <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div class="el-upload__tip" slot="tip">Click to upload avatar, only PNG/JPG files can be uploaded, and the file size should not exceed 2M</div>
                  </el-upload>
                </el-form-item>
                <el-form-item prop="nickname" label="Nickname:   ">
                  <el-input v-model="form.nickname"></el-input>
                </el-form-item>
                <el-form-item prop="user_name" label="UserName:   ">
                  <el-input v-model="form.user_name"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" style="margin-bottom:83px" @click="save('form')">Save</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import CenterMenu from '../components/CenterMenu'
import { mapActions } from 'vuex'
import * as uplpadAPI from '@/api/upload/'
import * as userAPI from '@/api/users/'
export default {
  name: 'Details',
  data() {
    var validateNick = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter a nickname'))
      } else if (value.length < 2 || value.length > 10) {
        callback(new Error('Nickname length should be between 2 and 10'))
      }
      callback()
    }
    var validateUser = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('enter one user name'))
      } else if (value.length < 5 || value.length > 15) {
        callback(new Error('The username length should be between 5 and 15'))
      }
      callback()
    }
    return {
      imageUrl: '',
      form: {
        id: 0,
        nickname: '',
        avatar: '',
        user_name: ''
      },
      rules: {
        nickname: [{ validator: validateNick, trigger: 'blur' }],
        user_name: [{ validator: validateUser, trigger: 'blur' }]
      }
    }
  },
  methods: {
    ...mapActions(['setUser']),
    fnBeforeUpload(file) {
      const isPNG = file.type === 'image/png' || file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isPNG) {
        this.$message.error('Uploading avatar images can only be in PNG/JPG format!')
      }
      if (!isLt2M) {
        this.$message.error('The size of the uploaded avatar image cannot exceed 2MB!')
      }
      return isPNG && isLt2M
    },
    fnUploadRequest(option) {
      uplpadAPI
        .UploadAvatar(option.file.name)
        .then(res => {
          if (res.status === 200) {
            const oReq = new XMLHttpRequest()
            oReq.open('PUT', res.data.put, true)
            oReq.send(option.file)
            oReq.onload = () => {
              this.imageUrl = res.data.get
              this.form.avatar = res.data.key
            }
          } else if (res.status === 20001) {
            //token过期，需要重新登录
            this.loginExpired(res.msg)
          } else {
            this.notifyError('Upload Failed', res.msg)
          }
        })
        .catch(error => {
          this.notifyError('Modify Failed', error)
        })
    },
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) {
          return
        }
        userAPI
          .updateUser(this.form)
          .then(res => {
            if (res.status === 200) {
              // 登录信息存到本地
              let user = JSON.stringify(res.data)
              localStorage.setItem('user', user)
              // 登录信息存到vuex
              this.setUser(res.data)
              this.notifySucceed('Success')
              this.$router.push({
                name: 'Center'
              })
            } else if (res.status === 20001) {
              //token过期，需要重新登录
              this.loginExpired(res.msg)
            } else {
              this.notifyError('Modify Failed', res.msg)
            }
          })
          .catch(error => {
            this.notifyError('Modify Failed', error)
          })
      })
    }
  },
  beforeMount() {
    this.form.id = this.$store.getters.getUser.id
    this.form.user_name = this.$store.getters.getUser.user_name
    this.form.nickname = this.$store.getters.getUser.nickname
    this.imageUrl = this.$store.getters.getUser.avatar
  },
  components: {
    CenterMenu
  }
}
</script>
<style>
.user-details-layout {
  max-width: 1225px;
  margin: 0 auto;
}
.user-details-content {
  background-color: #ffffff;
  margin-bottom: 30px;
}
.user-details-title {
  height: 100px;
  display: flex;
  align-items: center;
}
.user-details-title p {
  font-size: 30px;
  color: #757575;
  margin-left: 50px;
}
.user-details-form {
  width: 500px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 100%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #D4782F;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  max-width: 178px;
  max-height: 178px;
  border-radius: 100%;
  display: block;
}
.extra {
  height: 10px;
}
</style>